export default function (num) {
  return ('00' + num).slice(-2)
}



// WEBPACK FOOTER //
// ./src/misc/zeroPadding.js